import { ComponentTypes } from "../../config/config";

export interface IDroppedFileListSettingsTarget {
  currentDirectory: any;
  isOneDrive: boolean;
  siteUrl: string;
  listId?: string;
  driveId?: string;
  itemId?: string;
}

export type ResolveSiteWebUrl = (siteId: string) => Promise<string>;

export const isGraphDriveId = (value?: string): boolean => {
  return value?.trim().toLowerCase().startsWith("b!") === true;
};

const graphGuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const isGraphSiteId = (value?: string): boolean => {
  const trimmedValue = value?.trim();
  if (!trimmedValue) {
    return false;
  }

  return trimmedValue.split(",").length === 3 || graphGuidPattern.test(trimmedValue);
};

const getCurrentDirectory = (item: any): any => {
  return Array.isArray(item?.locations) && item.locations.length > 0
    ? item.locations[item.locations.length - 1]
    : item;
};

const getDirectSiteUrl = (currentDirectory: any): string => {
  return currentDirectory?.siteUrl
    || currentDirectory?.sharePointSiteUrl
    || currentDirectory?.webUrl
    || "";
};

const resolveSiteUrl = async (
  currentDirectory: any,
  resolveSiteWebUrl: ResolveSiteWebUrl
): Promise<string> => {
  const directSiteUrl = getDirectSiteUrl(currentDirectory);
  if (directSiteUrl) {
    return directSiteUrl;
  }

  const parentId = currentDirectory?.parentId;
  if (isGraphSiteId(parentId) && !isGraphDriveId(parentId)) {
    return await resolveSiteWebUrl(parentId);
  }

  return "";
};

const getOneDriveIdentity = (currentDirectory: any): { driveId?: string; itemId?: string } => {
  if (currentDirectory?.parentId) {
    return {
      driveId: currentDirectory.parentId,
      itemId: currentDirectory.id,
    };
  }

  return {
    driveId: currentDirectory?.driveId || currentDirectory?.id,
    itemId: currentDirectory?.driveId ? currentDirectory?.id : undefined,
  };
};

export const resolveDroppedFileListSettingsTarget = async (
  item: any,
  resolveSiteWebUrl: ResolveSiteWebUrl
): Promise<IDroppedFileListSettingsTarget> => {
  const currentDirectory = getCurrentDirectory(item);
  const siteUrl = await resolveSiteUrl(currentDirectory, resolveSiteWebUrl);

  const isOneDrive = currentDirectory?.type === ComponentTypes.OneDrive
    || currentDirectory?.type === ComponentTypes.OneDriveSubFolder
    || currentDirectory?.isOneDrive === true;

  const oneDriveIdentity = isOneDrive ? getOneDriveIdentity(currentDirectory) : {};

  return {
    currentDirectory,
    isOneDrive,
    siteUrl,
    listId: currentDirectory?.sharePointListId,
    ...oneDriveIdentity,
  };
};
